// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root-provider-data {
    --ag-row-odd-bg-color: #ffffff;
    --ag-row-hover-bg-color: #f7f7f7;
    --ag-header-bg-color: #f1f1f1;
    --ag-header-text-color: #333;
    --ag-header-icon-color: #666666;

    .ag-theme-alpine {
        background-color: var(--ag-row-odd-bg-color);

        .ag-row-odd {
            background-color: var(--ag-row-odd-bg-color);
        }

        .ag-row-hover {
            background-color: var(--ag-row-hover-bg-color);
        }

        
        .ag-header-icon.ag-header-cell-menu-button {
            display: block !important; 
        }

        .ag-header {    
            background-color: var(--ag-header-bg-color);
            color: var(--ag-header-text-color);
            font-weight: bold;
        }

        .ag-row-selected {
            background-color: transparent !important;
            --ag-selected-row-background-color: transparent;
        }

        .ag-row-selected:before {
            display: none;
        }

        .ag-header-cell-filter-button {
            display: none !important;
        }
        
        /* .ag-icon-filter::before {
            content: "" !important;
            display: none !important; 
        } */

        .ag-header-row.ag-header-row-column-filter {
            transition: none !important;
        }

      

        .ag-icon-menu-alt{
            color: var(--ag-header-icon-color) !important;
        }

        .ag-header-icon.ag-header-cell-menu-button:hover {
            color: var(--ag-header-icon-color) !important;
        }

        /* .ag-cell{
            padding-left: 8px !important;
            padding-right: 8px !important;
            display: inline-block !important;
            white-space: nowrap !important;
            overflow: hidden !important;
            text-overflow: ellipsis !important;
        } */

    }
}
`, "",{"version":3,"sources":["webpack://./src/components/manageproviders/data-grid/ManageProviderDataGridNew.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,gCAAgC;IAChC,6BAA6B;IAC7B,4BAA4B;IAC5B,+BAA+B;;IAE/B;QACI,4CAA4C;;QAE5C;YACI,4CAA4C;QAChD;;QAEA;YACI,8CAA8C;QAClD;;;QAGA;YACI,yBAAyB;QAC7B;;QAEA;YACI,2CAA2C;YAC3C,kCAAkC;YAClC,iBAAiB;QACrB;;QAEA;YACI,wCAAwC;YACxC,+CAA+C;QACnD;;QAEA;YACI,aAAa;QACjB;;QAEA;YACI,wBAAwB;QAC5B;;QAEA;;;WAGG;;QAEH;YACI,2BAA2B;QAC/B;;;;QAIA;YACI,6CAA6C;QACjD;;QAEA;YACI,6CAA6C;QACjD;;QAEA;;;;;;;WAOG;;IAEP;AACJ","sourcesContent":[".root-provider-data {\n    --ag-row-odd-bg-color: #ffffff;\n    --ag-row-hover-bg-color: #f7f7f7;\n    --ag-header-bg-color: #f1f1f1;\n    --ag-header-text-color: #333;\n    --ag-header-icon-color: #666666;\n\n    .ag-theme-alpine {\n        background-color: var(--ag-row-odd-bg-color);\n\n        .ag-row-odd {\n            background-color: var(--ag-row-odd-bg-color);\n        }\n\n        .ag-row-hover {\n            background-color: var(--ag-row-hover-bg-color);\n        }\n\n        \n        .ag-header-icon.ag-header-cell-menu-button {\n            display: block !important; \n        }\n\n        .ag-header {    \n            background-color: var(--ag-header-bg-color);\n            color: var(--ag-header-text-color);\n            font-weight: bold;\n        }\n\n        .ag-row-selected {\n            background-color: transparent !important;\n            --ag-selected-row-background-color: transparent;\n        }\n\n        .ag-row-selected:before {\n            display: none;\n        }\n\n        .ag-header-cell-filter-button {\n            display: none !important;\n        }\n        \n        /* .ag-icon-filter::before {\n            content: \"\" !important;\n            display: none !important; \n        } */\n\n        .ag-header-row.ag-header-row-column-filter {\n            transition: none !important;\n        }\n\n      \n\n        .ag-icon-menu-alt{\n            color: var(--ag-header-icon-color) !important;\n        }\n\n        .ag-header-icon.ag-header-cell-menu-button:hover {\n            color: var(--ag-header-icon-color) !important;\n        }\n\n        /* .ag-cell{\n            padding-left: 8px !important;\n            padding-right: 8px !important;\n            display: inline-block !important;\n            white-space: nowrap !important;\n            overflow: hidden !important;\n            text-overflow: ellipsis !important;\n        } */\n\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
